import { Badge, Card, Group, Text, Title } from "@mantine/core";
import { memo, type FC } from "react";
import { FormattedMessage } from "react-intl";
import type { Dataset, DatasetVersion } from "../types/dataset";
import type { AccountInfo } from "../../../../types/account";
import { getLocaleString } from "@project/common";
import { useLocale } from "../../../../hooks/locale";

interface DatasetItemCondensedProps {
  dataset: Dataset;
  version: DatasetVersion | null;
  account: AccountInfo;
}

export const DatasetItemCondensed: FC<DatasetItemCondensedProps> = memo(({ dataset }) => {
  const locale = useLocale();
  const { scope, displayName, description } = dataset;

  const displayNameText = getLocaleString(locale, displayName);
  const descriptionText = getLocaleString(locale, description);

  return (
    <Card withBorder shadow="sm" radius="md" p="sm">
      <Group justify="space-between" align="center">
        <Group>
          <Title order={4}>
            {displayNameText}
          </Title>
          {descriptionText && (
            <Text c="dimmed" size="sm" lineClamp={1}>
              {descriptionText}
            </Text>
          )}
          <Badge size="sm" color={scope === "private" ? "blue" : "green"}>
            {scope === "private"
              ? <FormattedMessage defaultMessage="Private" id="label.private" />
              : <FormattedMessage defaultMessage="Free" id="label.free" />}
          </Badge>
        </Group>
      </Group>
    </Card>
  );
});

DatasetItemCondensed.displayName = "DatasetItemCondensed";
